module.exports = __webpack_public_path__ + "fonts/VonwaonBitmap-12px.fa1a9e84.ttf";